<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <dash-sidebar
    defaultSelectedKeys="2"
    :menuItems="commonMenuItems.courseSubmitters"
    v-if="userRole === 'telas_course_submitters'"/>
    <dash-sidebar
    defaultSelectedKeys="2"
    :menuItems="commonMenuItems.admin"
    v-if="userRole === 'telas_telas_administrator'"/>

    <dash-sidebar
    defaultSelectedKeys="2"
    :menuItems="commonMenuItems.assessors"
    v-else />
    <a-layout>
      <a-layout-content
        :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }"
      >
        <a-tabs defaultActiveKey="1">
          <a-tab-pane tab="Assigned" key="1">
            <assessment-list-single :data="assessments.assigned" />
          </a-tab-pane>
          <a-tab-pane tab="In-Progress" key="2">
            <assessment-list-single :data="assessments.inProgress" />
          </a-tab-pane>
          <a-tab-pane tab="Completed" key="3">
            <assessment-list-single :data="assessments.completed" />
          </a-tab-pane>
        </a-tabs>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import dashSidebar from '@src/views/dashboard/Sidebar.vue';
import assessmentListSingle from './Assessment-list-single.vue';

export default {
  name: 'course-submitter-dashboard',
  components: {
    dashSidebar,
    assessmentListSingle,
  },
  computed: {
    ...mapState('user', {
      userDetails: state => state.userDetails,
    }),
    ...mapState('assessments', {
      assessments: state => state.assessmentByUser,
    }),
    ...mapGetters('user', {
      userRole: 'getUserRole',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      let getAssignedAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'assigned',
        assessmentStatus: 'assigned',
        status: 'publish',
      };
      getAssignedAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getAssignedAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getAssignedAssessmentsArgs;
      this.getAssessments(getAssignedAssessmentsArgs);
      let getInProgressAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'in-progress',
        assessmentStatus: 'in-progress',
        status: 'publish',
      };
      getInProgressAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getInProgressAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getInProgressAssessmentsArgs;
      this.getAssessments(getInProgressAssessmentsArgs);
      let getCompletedAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'completed',
        assessmentStatus: 'completed',
        status: 'publish',
      };
      getCompletedAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getCompletedAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getCompletedAssessmentsArgs;
      this.getAssessments(getCompletedAssessmentsArgs);
    });
  },
  methods: {
    ...mapActions('user', {
      validateToken: 'validateToken',
    }),
    ...mapActions('dashboard', {
      getCoursesByUser: 'getCoursesByUser',
    }),
    ...mapActions('assessments', {
      getAssessments: 'getAssessments',
    }),
  },
  watch: {
    userDetails() {
      let getAssignedAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'assigned',
        assessmentStatus: 'assigned',
      };
      getAssignedAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getAssignedAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getAssignedAssessmentsArgs;
      this.getAssessments(getAssignedAssessmentsArgs);
      let getInProgressAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'in-progress',
        assessmentStatus: 'in-progress',
      };
      getInProgressAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getInProgressAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getInProgressAssessmentsArgs;
      this.getAssessments(getInProgressAssessmentsArgs);
      let getCompletedAssessmentsArgs = {
        'filter[meta_key]': 'assessment_status',
        'filter[meta_value]': 'completed',
        assessmentStatus: 'completed',
      };
      getCompletedAssessmentsArgs = this.userRole !== 'telas_telas_administrator' ? { ...getCompletedAssessmentsArgs, ...{ author: this.userDetails.user_id } } : getCompletedAssessmentsArgs;
      this.getAssessments(getCompletedAssessmentsArgs);
    },
  },
};
</script>
